<template>
  <div class="assistant-card">
    <p v-if="!customers.length" class="customer-empty">
      No se encontraron clientes
    </p>
    <label
      v-for="customer in customers"
      :key="customer.personaId"
      class="customer-option"
      :class="{ 'is-selected': selectedId === customer.personaId }"
    >
      <input
        type="radio"
        :name="cardId"
        :checked="selectedId === customer.personaId"
        @change="$emit('select', customer)"
      />
      <span class="customer-option__body">
        <span class="customer-option__name">{{ customer.name }}</span>
        <span class="customer-option__meta">
          #{{ customer.personaId }}
          <template v-if="customer.email"> · {{ customer.email }}</template>
          <template v-if="customer.phone"> · {{ customer.phone }}</template>
        </span>
      </span>
    </label>
  </div>
</template>

<script>
// Candidatos de find_customer; el elegido es el de la cotización
export default {
  name: "CustomerOptionsCard",
  props: {
    cardId: { type: String, required: true },
    customers: { type: Array, required: true },
    selectedId: { type: [String, Number], default: null }
  }
};
</script>

<style lang="scss" scoped>
@import "./card.scss";

.customer-empty {
  font-size: 12px;
  color: #b91c1c;
}
.customer-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background: #f9fafb;
  }
  &.is-selected {
    border-color: #2563eb;
    background: #eff6ff;
  }
}
.customer-option__body {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.customer-option__meta {
  font-size: 11px;
  color: #6b7280;
}
</style>
